import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Masks an account number showing only the last 4 digits.
 * Handles short numbers by padding with asterisks.
 * @param accountNumber - The account number to mask
 * @returns Masked account number in format ****XXXX
 */
export function maskAccountNumber(accountNumber: string): string {
  return `****${accountNumber.slice(-4).padStart(4, '*')}`
}